<template>
  <router-link
    tag="div"
    class="home__tour-card"
    :style="{background: `url(${tour.previewImage}) 50% 0% / cover no-repeat`, boxShadow: boxShadow}"
    :event="isMobile ? 'click' : ''"
    :to="`/${tour.id}`"
  >
    <div class="tour-card__tag" :style="{backgroundColor: tour.primaryColor}">{{tour.title}}</div>
    <div class="tour-card__bar" :style="{backgroundColor: hexToRgba(tour.secondaryColor, 0.6)}">
      <div class="tour-card__text">{{tour.shortDescription}}</div>
      <router-link tag="button" class="tour-card__button" :to="`/${tour.id}`">Mehr Erfahren</router-link>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "HomeTourCard",
  data() {
    return {
      isMobile: false
    };
  },
  props: {
    tour: Object
  },
  computed: {
    boxShadow() {
      return `0 8px 28px -8px ${this.hexToRgba(
        this.tour.secondaryColor,
        0.3
      )}, 0 56px 100px -56px ${this.hexToRgba(this.tour.secondaryColor, 0.7)}`;
    }
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 768;
    },
    hexToRgba(hex, opacity) {
      const c = "0x" + hex.substring(1);
      return (
        "rgba(" +
        [(c >> 16) & 255, (c >> 8) & 255, c & 255, opacity].join(",") +
        ")"
      );
    }
  }
};
</script>

<style scoped lang="scss">
.home__tour-card {
  width: 320px;
  height: 357px;
  border-radius: 16px;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
  margin: 16px;
}

.tour-card__tag {
  border-radius: 4px;
  line-height: 17px;
  position: absolute;
  padding: 4px 8px;
  left: 16px;
  top: 16px;
  font-size: 14px;
  letter-spacing: 0.18px;
  color: #ffffff;
}

.tour-card__bar {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  min-height: 153px;
  border-bottom-right-radius: 16px;
  border-bottom-left-radius: 16px;
  font-family: "Playfair Display";
  font-size: 20px;
  line-height: 1.2;
  letter-spacing: 0.25px;
  color: #ffffff;
  text-align: left;
  padding: 24px;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
}

.tour-card__text {
  font-family: "Playfair Display";
  font-size: 20px;
  line-height: 1.2;
  letter-spacing: 0.25px;
  color: #ffffff;
  text-align: left;
}

.tour-card__button {
  display: block;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.2);
  //font-family: SoleilSb;
  font-family: Lato;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.7px;
  color: #ffffff;
  text-transform: uppercase;
  text-align: center;
  padding: 10px 0;
  width: 100%;
  line-height: 20px;
  cursor: pointer;
  margin-top: 18px;
}

@media (max-width: 767px) {
  .home__tour-card {
    width: 100%;
    height: 216px;
    margin: 12px;
    padding-top: 70%;
    max-width: 450px;
  }

  .tour-card__button {
    display: none;
  }

  .tour-card__bar {
    min-height: unset;
    padding: 20px 24px;
  }
}
</style>
